import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { useState, useRef, useEffect } from 'react';
import React from 'react';
interface IProps {
  id?: string;
  contactNumber?: number;
  onChange?: any;
  open?: boolean;
}

const FixedDialCodePhoneInput = ({ id, contactNumber, onChange, open }: IProps) => {
  const [value, setValue] = useState<any>('');
  const inputRef = useRef<HTMLInputElement>(null);
  const [dialCode, setDialCode] = useState('+61'); // default là Úc

  const handleChange = (val: string, data: any) => {
    const newDialCode = `+${data?.dialCode}`;
    setDialCode(newDialCode);
    onChange(val);
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    const pos = inputRef.current?.selectionStart || 0;
    if (pos <= dialCode.length && (e.key === 'Backspace' || e.key === 'Delete')) {
      e.preventDefault(); // Ngăn xóa mã vùng
    }
  };

  useEffect(() => {
    setValue(contactNumber);
  }, [contactNumber, dialCode]);

  useEffect(() => {
    const flagIcons = document.querySelectorAll('.fixed-dial-code-phone-input .selected-flag .flag');
    flagIcons.forEach(flagIcon => flagIcon.setAttribute('name', 'phone-input-flag-icon'));
  }, [open, value]);

  return (
    <PhoneInput
      // country={isShowCountry ? 'au' : ''}
      value={value}
      onChange={handleChange}
      containerClass="fixed-dial-code-phone-input"
      inputProps={{
        id,
        ref: inputRef,
        onKeyDown: handleKeyDown,
        required: true,
        name: 'phone',
      }}
    />
  );
};

export default FixedDialCodePhoneInput;
